<template>
  <Page>
    <template #deck>
      <p
        v-if="cart && !isEmpty"
        class="md:text-md text-sm font-thin tracking-wide text-white"
      >
        {{ cartQuantity }} <span v-if="cartQuantity > 1">items</span><span v-else>item</span>
      </p>
    </template>
    <div
      class="mb-4 flex-1 space-y-4"
      :class="{ 'flex': isEmpty, 'flex-col': isEmpty }"
    >
      <div
        :class="[
          isEmpty
            ? '  flex flex-1 flex-col items-center justify-center rounded-lg border border-gray-400'
            : '',
        ]"
      >
        <div
          v-if="cart?.lines.edges.length > 0 || cartQuantity > 0"
          key="cart"
        >
          <table
            class="w-full table-auto border-separate border-spacing-0 rounded-b-lg bg-gray-100"
          >
            <thead class="hidden lg:table-header-group">
              <tr>
                <th
                  class="text-uppercase am-heading rounded-tl-lg bg-gray-800 px-4 py-3 text-left text-xs tracking-widest text-white"
                  colspan="2"
                >
                  Item
                </th>
                <th
                  class="text-uppercase am-heading bg-gray-800 py-3 pl-6 text-xs tracking-widest text-white"
                >
                  Quantity
                </th>
                <th class="bg-gray-800" />
                <th
                  class="text-uppercase am-heading rounded-tr-lg bg-gray-800 py-3 pl-4 pr-8 text-right text-xs tracking-widest text-white"
                >
                  Price
                </th>
              </tr>
            </thead>

            <!-- <TransitionGroup
              name="list"
              tag="tbody"
              class="rounded-b-lg shadow-md"
            > -->
            <tbody class="rounded-b-lg shadow-md">
              <CartItem
                v-for="(line, index) in cart.lines.edges"
                :key="line.node.id"
                :item="line.node"
                :index="index"
              />
            </tbody>
            <!-- </TransitionGroup> -->

            <tfoot>
              <tr class="">
                <td
                  class="p-6 text-left tracking-wide lg:text-right"
                  colspan="5"
                >
                  <p>
                    <span class="font-bold">Subtotal:</span>
                    {{ subtotal }}
                  </p>
                  <p class="mb-4 text-sm italic">
                    Shipping, taxes, and discount codes calculated at checkout.
                  </p>
                  <p>
                    <UButton
                      class="font-bold"
                      size="xl"
                      icon="i-heroicons-arrow-right"
                      trailing
                      :loading="isCheckingOut"
                      @click="onCheckout"
                    >
                      Checkout
                    </UButton>
                  </p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div
          v-else
          key="empty"
          class="p-12 text-center"
        >
          <p class="mb-6 text-3xl font-light">
            Your cart is empty.
          </p>
          <UButton
            to="/shop"
            size="xl"
            class="mr-3 font-bold"
          >
            Continue Shopping
          </UButton>

          <UButton
            to="/login"
            size="xl"
            variant="outline"
          >
            Have an account? Log in
          </UButton>
        </div>
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
const store = useStore()
const { cart, cartQuantity, cartId, currentCountry } = storeToRefs(store)

const isCheckingOut = ref(false)
const isEmpty = computed(() => cartQuantity.value === 0)

await useAsyncData("cart", () => store.fetchCartById(cartId.value))

const subtotal = computed(() =>
  formatPrice(
    cart.value.cost.subtotalAmount.amount,
    currentCountry.value.isoCode,
    currentCountry.value.currency.isoCode,
  ),
)

const onCheckout = () => {
  console.log("onCheckout")
  isCheckingOut.value = true

  const checkoutUrl: URL = new URL(cart.value.checkoutUrl)
  console.log(checkoutUrl)
  checkoutUrl.searchParams.append("logged_in", "true")
  console.log(checkoutUrl.toString())
  navigateTo(checkoutUrl.toString(), { external: true })
}

useHead({
  title: "Your Cart",
})

definePageMeta({
  title: "Your Cart",
  layout: "wide",
})
</script>

<style scoped>
/* .list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8  {
  opacity: 0;
  transform: translateX(30px);
} *

*/

.list-enter-active[data-single="true"],
.list-leave-active[data-single="true"] {
  transition: all 0s;
}
</style>
